import React__default, { useRef, useState, useEffect } from 'react';
import Styles from './CustomCarousel.module.scss.js';
import classNames from 'classnames';
import { useIntersect } from '../../hooks/useIntersect.js';

const CustomCarousel = ({ children, containerClass, rowClass, itemClass, activeClass, nextArrowClass, prvArrowClass, prevNextBtnsClass, scrollBy, items, fallback, prvArrow, nextArrow, length, dotsClass, activeDotClass }) => {
    const elmRef = useRef(null);
    const itemRef = useRef(null);
    const [scrollByitemWidth, setScrollByitemWidth] = useState(0);
    const [isLastItem, setIsLastItem] = useState(false);
    const [isFirstItem, setIsFirstItem] = useState(false);
    const [currentItem, setCurrentItem] = useState(0);
    const [isMouseOver, setIsMouseOver] = useState(false);
    useEffect(() => {
        if (scrollByitemWidth) {
            scrollHorizontal(scrollByitemWidth);
        }
    }, [scrollByitemWidth, currentItem]);
    const { entry: lastInterSectionObj, setNode: lastElmRef } = useIntersect({
        // rootMargin: getHeightByViewPort(0),
        threshold: 1
    });
    useEffect(() => {
        if ((lastInterSectionObj === null || lastInterSectionObj === void 0 ? void 0 : lastInterSectionObj.intersectionRatio) === 1) {
            setIsLastItem(true);
        }
        else {
            setIsLastItem(false);
        }
        return () => {
            setIsLastItem(false);
        };
    }, [lastInterSectionObj, length]);
    const { entry: firstInterSectionObj, setNode: firstElmRef } = useIntersect({
        // rootMargin: getHeightByViewPort(0),
        threshold: 1
    });
    useEffect(() => {
        if ((firstInterSectionObj === null || firstInterSectionObj === void 0 ? void 0 : firstInterSectionObj.intersectionRatio) === 1) {
            setIsFirstItem(true);
        }
        else {
            // if (items?.length === 1) {
            //     setIsLastItem (false)
            // }
            setIsFirstItem(false);
        }
        return () => {
            setIsFirstItem(false);
        };
    }, [firstInterSectionObj, length]);
    const scrollHorizontal = (scrollOffset) => {
        elmRef.current.scrollLeft += scrollOffset;
        setScrollByitemWidth(0);
    };
    const handlePrvArrow = (event) => {
        if (isFirstItem) {
            setScrollByitemWidth(itemRef.current.offsetWidth * length);
            setCurrentItem(length - 1);
        }
        else {
            setScrollByitemWidth(itemRef.current.offsetWidth * scrollBy * -1);
            setCurrentItem(currentItem - 1);
        }
        event.target.setAttribute("disabled", true);
        setTimeout(function () {
            event.target.removeAttribute("disabled");
        }, 800);
    };
    const handleNextArrow = (event) => {
        if (isLastItem) {
            setScrollByitemWidth(itemRef.current.offsetWidth * length * -1);
            setCurrentItem(0);
        }
        else {
            setScrollByitemWidth(itemRef.current.offsetWidth * scrollBy);
            setCurrentItem(currentItem + 1);
        }
        event.target.setAttribute("disabled", true);
        setTimeout(function () {
            event.target.removeAttribute("disabled");
        }, 800);
    };
    const prevCountRef = useRef();
    useEffect(() => {
        prevCountRef.current = currentItem;
    }, [currentItem]);
    const prevCount = prevCountRef.current;
    useEffect(() => {
        if (itemRef.current)
            if (currentItem > prevCount) {
                setScrollByitemWidth(itemRef.current.offsetWidth * (currentItem - prevCount));
            }
            else {
                setScrollByitemWidth(itemRef.current.offsetWidth * (prevCount - currentItem) * -1);
            }
    }, [currentItem, itemRef]);
    const onClickDotHandleItems = (targetItem) => {
        setCurrentItem(targetItem);
    };
    useEffect(() => {
        let interval;
        if (!isMouseOver) {
            interval = setInterval(() => {
                if (currentItem < length - 1) {
                    setCurrentItem((count) => count + 1);
                }
                else {
                    setCurrentItem((count) => count - (length - 1));
                }
            }, 5000);
        }
        else {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval);
        };
    }, [currentItem, isMouseOver]);
    const onMouseEnterStopInterval = () => {
        setIsMouseOver(true);
    };
    const onMouseLeaveStartInterval = () => {
        setIsMouseOver(false);
    };
    return (React__default.createElement("div", { className: classNames(Styles.main, containerClass) },
        ((items === null || items === void 0 ? void 0 : items.length) || children) && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { ref: elmRef, className: classNames(Styles.row, rowClass) }, items === null || items === void 0 ? void 0 :
                items.map((item, index) => (React__default.createElement("div", { key: index, ref: index === 0 ? firstElmRef : index === items.length - 1 ? lastElmRef : itemRef, className: classNames(Styles.item, itemClass, currentItem === index && activeClass), onMouseEnter: onMouseEnterStopInterval, onMouseLeave: onMouseLeaveStartInterval }, item))),
                children),
            prvArrow && items && items.length > 1 ? (React__default.createElement("button", { className: classNames(Styles.prev, prvArrowClass), onClick: (e) => handlePrvArrow(e) }, prvArrow)) : (React__default.createElement(React__default.Fragment, null)),
            nextArrow && items && items.length > 1 ? (React__default.createElement("button", { className: classNames(Styles.next, nextArrowClass), onClick: (e) => handleNextArrow(e) }, nextArrow)) : (React__default.createElement(React__default.Fragment, null)),
            items && items.length > 1 ? (React__default.createElement("div", { className: classNames(Styles.dots, dotsClass) }, items === null || items === void 0 ? void 0 : items.map((data, index) => (React__default.createElement("span", { key: index, className: classNames(Styles.dot, currentItem === index && Styles.activeDot, currentItem === index && activeDotClass), onClick: () => onClickDotHandleItems(index) }))))) : (React__default.createElement(React__default.Fragment, null)))),
        fallback));
};

export { CustomCarousel as default };
//# sourceMappingURL=CustomCarousel.js.map
